import React, { useContext, useState } from "react";

import styled from "styled-components";
import Headshot from "../UI/Profile/Headshot";
import { BsExclamationDiamond } from "react-icons/bs";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { Button } from "../../Theme/Hyper";
import ConfirmModal from "../Modals/ConfirmModal";
import { DataContext } from "../../contexts/DataContext";
import Image from "../UI/Image";

const Main = styled.div`
  border-color: #dee2e6;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 3px !important;
  width: 100%;
  overflow: hidden;
`;
const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
  > tbody > tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, 0.05);
  }
  th:nth-child(1) {
    width: 30px;
  }
  th:nth-child(2) {
    width: 65px;
  }

  th {
    padding: 10px;
    border-top: 1px solid #dee2e6;
  }
  td {
    padding: 10px;
    border-top: 1px solid #dee2e6;
    width: ${(props) => props.width};
    border-top: 1px solid #dee2e6;
    white-space: nowrap;
    overflow: hidden;
    font-size: 0.8em;
  }
  > tbody > tr:hover {
    background-color: #14ec8e;
    color: white;
    cursor: pointer;
  }
  td.icons {
    padding: 0px;
    font-size: 20px;
    padding-top: 3px;
  }
`;

const TH = styled.th`
  border-top: 0;
  border-bottom: 0;
  font-weight: 800;
  font-size: 0.8em;
  text-transform: uppercase;
  color: #343a40;
  text-align: left;
`;

const Alert = styled(BsExclamationDiamond)`
  color: red;
  margin-right: 10px;
`;

const Off = styled(IoIosArrowDown)`
  color: #db0a41;
  font-size: 20px;
`;
const On = styled(IoIosArrowUp)`
  color: #0adb93;
  font-size: 20px;
`;
export default function Lineup({
  squad,
  selectPlayer,
  showNumber,
  showTeam,
  team,
  onChange,
  showActive,
}) {
  const [merge, setMerge] = useState(false);
  const [mergePlayer, setMergePlayer] = useState();
  const [mergePlayer2, setMergePlayer2] = useState();
  const [confirmMerge, setConfirmMerge] = useState(false);
  const { mergePlayers } = useContext(DataContext);
  const [sort, setSort] = useState("shirt_number");
  const project_serevr_url =
    window.ENV?.REACT_APP_PROJECT_SERVER ||
    process.env.REACT_APP_PROJECT_SERVER;
  const userId =
    localStorage.getItem("team-owner-id") ?? localStorage.getItem("user-id");
  function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

  return (
    <Main>
      <Table showNumber={showNumber}>
        <thead>
          <tr>
            <TH
              onClick={() => {
                setSort("shirt_number");
              }}
            >
              #
            </TH>
            <TH></TH>
            <TH
              onClick={() => {
                setSort("first_name");
              }}
            >
              First
            </TH>
            <TH
              onClick={() => {
                setSort("last_name");
              }}
            >
              Last
            </TH>
            <TH
              onClick={() => {
                setSort("first_name_upper");
              }}
            >
              First Upper
            </TH>
            <TH
              onClick={() => {
                setSort("last_name_upper");
              }}
            >
              Last Upper
            </TH>
            <TH
              onClick={() => {
                setSort("short_name");
              }}
            >
              Short Name
            </TH>
            <TH
              onClick={() => {
                setSort("short_name_upper");
              }}
            >
              Short Name Upper
            </TH>
            {showTeam && <TH>Team</TH>}
            <TH>Country</TH>
            <TH>Position</TH>
            <TH>Active</TH>
            <TH></TH>
          </tr>
        </thead>
        <tbody>
          {squad
            ?.filter(
              (l) =>
                l.type === "player" &&
                (l.active === true || (showActive && l.active === false))
            )
            ?.sort((a, b) => {
              if (showNumber) {
                return (a.order || 999) - (b.order || 999);
              } else {
                let a_value = a[sort] || a?.player?.[sort];
                let b_value = b[sort] || b?.player?.[sort];

                if (isNumeric(a_value)) {
                  return (a_value || 999) - (b_value || 999);
                } else {
                  if (a_value < b_value) {
                    return -1;
                  }
                  if (a_value > b_value) {
                    return 1;
                  }
                  return 0;
                }
              }
            })
            ?.slice(0, showNumber && 15)
            ?.map((squad, index) => {
              let player = squad.player;
              return (
                <tr
                  key={index}
                  onClick={() => {
                    selectPlayer(squad);
                  }}
                >
                  <td>{squad.shirt_number || squad.opta_shirt_number}</td>
                  <td>
                    {player?.image && (
                      <img
                        style={{
                          objectFit: "contain",
                          width: "50px",
                          height: "30px",
                        }}
                        src={
                          project_serevr_url +
                          "/api/assets/images/thumbnail/" +
                          userId +
                          "/" +
                          encodeURIComponent(player?.image || "")
                        }
                        alt="Player"
                      />
                    )}
                  </td>
                  <td>{player.first_name}</td>
                  <td>{player.last_name}</td>
                  <td>{player.first_name_upper}</td>
                  <td>{player.last_name_upper}</td>
                  <td>{player.short_name}</td>
                  <td>{player.short_name_upper}</td>
                  {showTeam && <td>{player.team && player.team.name}</td>}
                  <td>
                    {/* <Image
                        style={{ height: "20px", width: "auto" }}
                        url={
                          "__SKY_SPORTS/GLOBALS/FLAGS/" +
                          ((player.nationality &&
                            player.nationality.code.toLowerCase()) ||
                            "")
                        }
                        placeholder={""}
                      /> */}
                    {(player.nationality && player.nationality.opta_code) || ""}
                  </td>
                  <td>{squad.position || squad.opta_position || ""}</td>
                  <td>{squad?.active ?? squad?.opta_active ? "yes" : "no"}</td>

                  <td>
                    {player && player.subbed && player.order <= 15 && <On />}
                    {player && player.subbed && player.order > 15 && <Off />}
                  </td>
                </tr>
              );
            })}
        </tbody>
      </Table>
      {showNumber && (
        <Table showNumber={showNumber}>
          <thead>
            <tr>
              {showNumber && (
                <TH style={{ textAlign: "center" }}>Substitutes</TH>
              )}
              <TH></TH>
              <TH></TH>
              <TH></TH>
              <TH></TH>
              {showTeam && <TH></TH>}
              <TH></TH>
              <TH style={{ width: "25px" }}></TH>
            </tr>
          </thead>
          <tbody>
            {squad &&
              squad
                .filter((l) => l.type === "player")
                .sort((a, b) => {
                  if (showNumber) {
                    return (a.order || 999) - (b.order || 999);
                  } else {
                    return (a.shirt_number || 999) - (b.shirt_number || 999);
                  }
                })
                .slice(15)
                .map((player, index) => {
                  return (
                    <tr
                      onClick={() => {
                        selectPlayer(player);
                      }}
                    >
                      {/* {showNumber && <td>{player.order}</td>} */}
                      <td>
                        {player._id && team && (
                          <Headshot
                            image={
                              "/" +
                              (team.name || player.team) +
                              "/Home/" +
                              player.head_shots.find(
                                (p) => p.type === "standard"
                              ).url
                            }
                          />
                        )}
                      </td>
                      <td>{player.shirt_number}</td>
                      <td>{player.first_name}</td>
                      <td>{player.last_name}</td>
                      {showTeam && <td>{player.team && player.team.name}</td>}
                      <td>
                        {(player.nationality && player.nationality.code) || ""}
                      </td>
                      <td>{player.position || ""}</td>
                      <td></td>
                      <td></td>
                      <td>
                        {player && player.subbed && player.order <= 15 && (
                          <On />
                        )}
                        {player && player.subbed && player.order > 15 && (
                          <Off />
                        )}
                      </td>
                    </tr>
                  );
                })}
          </tbody>
        </Table>
      )}
      <ConfirmModal
        title="Are you sure you want to merge players?"
        show={confirmMerge}
        onConfirm={() => {
          mergePlayers({
            manual_player: mergePlayer,
            opta_player: mergePlayer2,
          }).then(() => {
            onChange();
            setMerge(false);
            setConfirmMerge(false);
          });
        }}
        onCancel={() => {
          setMerge(false);
          setConfirmMerge(false);
        }}
      ></ConfirmModal>
    </Main>
  );
}
